import { createAction } from '../../Helpers/Action.helpers';
import { ICustomerSimple } from '../../Models/DTO/Customer.model';
import { SearchCustomer } from '../../Models/DTO/SearchCustomer.model';
import { BOOKING_LIST_ACTIONS } from '../../Constants/Actions.constants';

export const requestCustomer = (customer: ICustomerSimple | SearchCustomer) =>
  createAction({
    name: BOOKING_LIST_ACTIONS.SELECT_CUSTOMER,
    type: BOOKING_LIST_ACTIONS.SELECT_CUSTOMER,
    payload: customer,
  });

export const requestClearSelectedCustomers = () =>
  createAction({
    name: BOOKING_LIST_ACTIONS.CLEAR_SELECTED_CUSTOMERS,
    type: BOOKING_LIST_ACTIONS.CLEAR_SELECTED_CUSTOMERS,
  });
